<template>
  <div class="company-info">
    <div class="grid-row">
      <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
        <div class="form-field no-margin">
          <label>{{$_('type')}}</label>
          <Select
            :placeholder="$_('your_choice')"
            :itemoption="['TCCOM', 'TLIB_CCOM']"
            :data="type"
            @select-change="vSetStore('tccom', $event.item)"
          />
        </div>
      </div>
    </div>
    <div class="grid-row">
      <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
        <div class="form-field no-margin">
          <label>{{$_('turnover')}}</label>
          <Input :type="'number'" @typing="vSetStore('tca', $event)" />
        </div>
      </div>
      <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
        <div class="form-field no-margin">
          <label>{{$_('number_of_employees')}}</label>
          <Input :type="'number'" @typing="vSetStore('tnb_emp', $event)" />
        </div>
      </div>
    </div>
    <div class="grid-row">
      <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
        <div class="form-field no-margin">
          <label>{{$_('place_of_production')}}</label>
          <Input :type="'text'" @typing="vSetStore('tlieuprod', $event.toUpperCase()) " />
        </div>
      </div>
      <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
        <div class="form-field no-margin">
          <label>{{$_('other_suppliers')}}</label>
          <Input :type="'text'" @typing="vSetStore('taut_four', $event.toUpperCase())" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from "@/common/components/widget/Input/Input";
import Select from "@/common/components/widget/Select";

import customerService from "@/modules/client/services/customerService";

export default {
  name: "ProspectFormCompanyInfo",
  components: {
    Input,
    Select
  },
  data() {
    return {
      type: Array()
    };
  },
  created() {
    customerService.getTypeCom().then(res => {
      this.type = res.data.DS_O.OUT;
    });
  },
  methods: {
    vSetStore(key, value) {
      this.$store.dispatch("echantillon/SET_HEADER", { key, value });
    }
  }
};
</script>

<style scoped>
.company-info {
  border: solid 1px #e1e1e1;
  padding: 15px;
  border-radius: 8px;
}
@media screen  and (max-width: 800px) {
  .company-info {
    padding: 0px
  }
}
</style>